import React, { useState } from 'react';
import './achievements.css';

import image1 from "./images/thumb2.png";
import image2 from "./images/thumb.png";
import image3 from "./images/thumb3.png";
import image4 from "./images/HackFlow.jpeg";
import image5 from "./images/Hack4justice.jpg";
import image6 from "./images/MASSAI2025.jpg";
import image7 from "./images/SMUHACK.jpg";
import image8 from "./images/TuniHack.jpg";
import image9 from "./images/Samsung.jpg";
import image10 from "./images/ExpressFM.jpg";
import image11 from "./images/IEE.jpg";
import image12 from "./images/IFM.jpg";
import image13 from "./images/Deepflow.jpg";

import { Link } from 'react-router-dom';

const achievements = [
  {
    id: 1,
    title: 'HACKATHON 6.0',
    description: 'by ATLAS TBS',
    image: image1,
    demoLink: "/HACKATHON6.0",
   
  },
  {
    id: 2,
    title: 'Sustainable Minds²',
    description: 'by SSDteam & Esprit',
    image: image2,
    demoLink:"/HackMinds",

  },
  {
    id: 3,
    title: 'GreenAct',
    description: 'by Esprit',
    image: image3,
    demoLink:"/HackEsprit",

  },
  {
    id: 4,
    title: 'AI HackFlow',
    description: 'By DeepFlow',
    image: image4,
    demoLink:"/HackFlow",

  },
  {
    id: 5,
    title: 'Hack4Justice',
    description: 'By RNE',
    image: image5,
    demoLink:"/Hack4Justice",

  },
  {
    id: 6,
    title: 'MASSAI 2025',
    description: 'by Esprit',
    image: image6,
    demoLink:"/MASSAI",

  },
  {
    id: 7,
    title: 'SMU Hackathon 2025',
    description: 'by SMU',
    image: image7,
    demoLink:"/SMUHack",

  },
  {
    id: 8,
    title: 'TuniHack 10.0',
    description: 'by TuniHack Team',
    image: image8,
    demoLink:"/TuniHack",

  },
  {
    id: 9,
    title: 'Samsung Inovation Campus',
    description: 'by Samsung',
    image: image9,
    demoLink:"/Samsung",

  },
  {
    id: 10,
    title: 'Express FM Interview',
    description: 'Featured Guest',
    image: image10,
    demoLink:"/ExpressFM",

  },
  {
    id: 11,
    title: 'IEEE ATEC 2024',
    description: 'by IEEE',
    image: image11,
    demoLink:"/IEEE",

  },
  {
    id: 12,
    title: 'Radio IFM Interview',
    description: 'Featured Guest',
    image: image12,
    demoLink:"/RadioIFM",

  },
  {
    id: 13,
    title: 'Linear Regression Workshop',
    description: 'Mentor @DeepFlow AI Club',
    image: image13,
    demoLink:"/LinearRegression",

  }

  
  // Add more project objects as needed 
];

const Achievements = () => {
  const [showAll, setShowAll] = useState(false);
  
  const initialAchievements = achievements.slice(0, 6);
  const additionalAchievements = achievements.slice(6);

  const displayedAchievements = showAll ? achievements : initialAchievements;

  return (
    <section className="portfolio section" id='achievements'>
    <div className="project-list" >
      <h2 className="section__title" >My Achievements</h2>
      <span className="section__subtitle">Have a look!</span>
      <div className="project-list__container">
        {displayedAchievements.map((achievement) => (
          <div className="project" key={achievement.id}>
            <div className="project__image">
              <img src={achievement.image} alt={achievement.title} />
            </div>
            <div className="project__content">
              <h3 className="project__title">{achievement.title}</h3>
              <p className="project__description">{achievement.description}</p>
              <div className="project__links">
                <Link to={achievement.demoLink} className='links__projects'>Details</Link>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {additionalAchievements.length > 0 && (
        <div className="achievements__toggle">
          <button 
            className="button button--small achievements__button"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'Show Less' : 'Show More'}
          </button>
        </div>
      )}
    </div>
    </section>
  );
};

export default Achievements;
